import "./css/learner_testimonial.css";

const LearnerTestimonial = ({
  heading,
  content,
  testifier_name,
  testifier_role,
  media_type,
  media_url,
  index,
}) => {
  return (
    <div className="learner_testimonial">
      <div className="top">
        {media_type === "image" ? (
          <img src={media_url} alt={index} />
        ) : (
          <div className="testimony_video_container">
            <video>
              <source src={media_url} type="video/mp4" />
            </video>
          </div>
        )}
        {media_type === "video" && (
          <button
            className="play_testimony"
            onClick={(e) => {
              const vid = e.target.parentElement.querySelector(
                ".testimony_video_container video"
              );
              if (vid.paused) {
                e.target.parentElement
                  .querySelector(".testimony_video_container video")
                  .play();
              } else {
                e.target.parentElement
                  .querySelector(".testimony_video_container video")
                  .pause();
              }
              e.target.classList.toggle("pause_testimony");
            }}
          ></button>
        )}
      </div>
      <div className="bottom">
        <h3>"{heading}"</h3>
        <p className="content">"{content}"</p>
        <p className="testifier_name_and_role">
          {testifier_name ? `- ${testifier_name}.,` : "-"}&nbsp;{testifier_role}
        </p>
      </div>
    </div>
  );
};

export default LearnerTestimonial;
